module.exports = __webpack_public_path__ + "img/vi.2150fa52.png";